import { SIGN_IN_USER, SIGN_OUT_USER } from "./authConstants";

export const AUTH_INITIAL_STATE = {
  authenticated: false,
  currentUser: null,
};

export default function authReducer(
  state = AUTH_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case SIGN_IN_USER:
      return {
        ...state,
        authenticated: true,
        currentUser: {
          email: payload.email,
          name: payload.displayName,
          id: payload.uid,
          photoURL: payload.photoURL,
          providerId: payload.providerData[0].providerId,
        },
      };
    case SIGN_OUT_USER:
      return {
        ...AUTH_INITIAL_STATE,
      };
    default:
      return state;
  }
}
